<div class=" d-none d-sm-block">
  <!------------------------------------------TITLE----------------------------------------------->
 <div class="title-box uk-border-rounded p-1 d-none d-sm-block">
  <div class="head-card p-1 inner-title-box">
    <h1 class="title-text text-light text-center font-weight-bold">
      web hosting & seo services
    </h1>
    <div class="text-right">
      <h5 class="text-light">
        <span class="sub-menu" routerLink="/home-page">Home </span>&nbsp;/&nbsp;
        <!-- <span class="sub-menu sub-menu-text font-weight-bold">Custom Software Development</span>&nbsp;/&nbsp; -->
        <span class="sub-menu" routerLink="/maintenance"> Application maintenance</span>
      </h5>
    </div>
  </div>
 </div>
<!--------------------------------------------------TITLE END-------------------------------------------->
<div class="bg-light">
<!--------------------------------------------------END------------------------------------------------------>
<!---------------------------------WEB-HOSTING---------------------------------------------------------------->
<div class="container-fluid">
  <h4 class="font-weight-bolder align-middle text-center text-uppercase d-block d-sm-none">
    web hosting
  </h4>
    <div class="row" >
    <div class="col-md-5 col-sm-12 col-xs-12 animatable bounceInLeft" style="margin-top: 1%;">
                <div class="bg-light">
                  <!-- <div class="top-sec"> -->
                    <img src="./../../../assets/img/service/web-host/img-01.jpg" style="width:100%;">
                  <!-- </div> -->
                  <div class="bottom-sec">
          
                  </div>
                </div>
    </div>
    <div class="col-md-7 col-sm-12 col-xs-12 animatable bounceInRight" style="margin-top: 1%;">
        <h3 class="font-weight-bold">Web Hosting</h3>
        <p class="justify-content-center" style="text-indent: 5%;">
            Web Space is a small portion of a web server owned or rented by a web hosting company. 
            This process of transferring a website into server web space is Web Hosting.
            Web hosting is basically a web space service provider. Factors to be considered while buying web 
            space are Server Softwares, Space and Capacity.
            The common server types are Windows 2000, Unix and Linux. Disk space or Web Space is the size of 
            space allotted on a particular server for uploading the web pages and Band Width is an amount of transfer
            from the web server through internet. For a basic website, there is no need to bother about server type, disk
            space and band width, but if a website has data base then server type is very important as database suppor
            depends on its type. For example, a website with MS SQL database
            cannot be store in Linux Server but only in the Windows server. Annaa Silicon is currently developing mobile apps and mobile software components on
            iOS, Android.
        </p>
    </div>
  </div>
</div>

<!----------------------------------------------WEB-HOSTING END----------------------------------------------->

<!------------------------------------------TYPES OF WEB HOSTING---------------------------------------------->
<div class="container-fluid p-4">
    <div class="row">
      <div class="col-md-7 col-sm-12 col-xs-12 animatable bounceInLeft" >
        <h3 class="font-weight-bold">Types of web hosting packages</h3>
          <p class="justify-content-center" style="text-indent: 5%;">
            <li>
              Dedicated Hosting is expensive however very secure and highly recommended for websites 
              with huge traffic /having e-Commerce Shopping
            </li>
            </p>
          <p class=" justify-content-center" style="text-indent: 5%;">
            <li>
              Shared Hosting is competitively priced where thousands of websites will be hosted and 
              they share the same server and its features and works great for websites without any commerce
              / performance need.
            </li>
            </p>
          <p class="justify-content-center" style="text-indent: 5%;">
            <li>
              Co-Located web hosting is similar to dedicated hosting. Instead of having a own server 
              can be rented out and to take responsibility of maintaining the server completely like 
              except electricity, storage and internet facility.
            </li>
            </p>
          <p class=" justify-content-center" style="text-indent: 5%;">
            <li>
              Free Hosting is available based on promotions and often recommended for temporary sites/news casts.
            </li>
            </p>
          <p class=" justify-content-center" style="text-indent: 5%;">
            <li>
              Reseller Hosting which is similar to shared hosting with additional features of extra tools 
              in order to Re-Sell the server or web space into many units to the end users under their own brand name.
            </li>
            </p>
           <p class=" justify-content-center" style="text-indent: 5%;"> 
            <li>
            Annaa Silicon is currently developing mobile apps and mobile software components on
              iOS, Android.
            </li>
            </p>
        </div>
        <div class="col-md-5 col-sm-12 col-xs-12 animatable bounceInRight"  >
          <div class="card">
              <!-- <div class="top-sec"> -->
                  <img src="./../../../assets/img/service/web-host/img-02.jpg"  style="width:100%;">
              <!-- </div> -->
              <div class="bottom-sec">
              </div>
          </div>
        </div>
    </div>
</div>

<!----------------------------------------------TYPES OF WEB HOSTING END--------------------------------------->


<!---------------------------------------------SEO SERVICES--------------------------------------------------->
<div class="container-fluid pb-3">
    <div class="row">
      <div class="col-md-5 col-sm-12 col-xs-12 animatable bounceInLeft" >
        <div class="card">
            <!-- <div class="top-sec"> -->
              <img src="./../../../assets/img/service/web-host/img-03.jpg"  style="width:100%;">
            <!-- </div> -->
            <div class="bottom-sec">
    
            </div>
        </div>
      </div>
      <div class="col-md-7 col-sm-12 col-xs-12 animatable bounceInRight" >
        <h3 class="font-weight-bold">SEO Services</h3>
        <p class="justify-content-center" style="text-indent: 5%;">
          Search Engine Optimization ( SEO ) is a process of making a website or a portal to be
          Search Engine Friendly, to bring that particular website or a portal with the Top Ranking on a
          Search Engine Ranking Page ( SERP ) as top as possible for a query raised while surfing.
          This drives more traffic to the website and in turn increase customers to the portal.
          This is very key for driving growth to a business.
          </p>
      </div>
    </div>
</div>
</div>
<!------------------------------------------SEO SERVICES--------------------------------------------------->
</div>



<!--------------------------------------- MOBILE VIEW ------------------------------------------------->

<div class=" d-block d-sm-none">
  <!------------------------------------------TITLE----------------------------------------------->
 <div class="title-box uk-border-rounded p-1 d-none d-sm-block">
  <div class="bg-dark p-1 inner-title-box">
    <h1 class="title-text text-center font-weight-bold">
      web hosting & seo services
    </h1>
    <div class="text-right">
      <h5 class="text-light">
        <span class="sub-menu" routerLink="/home-page">Home </span>&nbsp;/&nbsp;
        <!-- <span class="sub-menu sub-menu-text font-weight-bold">Custom Software Development</span>&nbsp;/&nbsp; -->
        <span class="sub-menu" routerLink="/maintenance"> Application maintenance</span>
      </h5>
    </div>
  </div>
 </div>
<!--------------------------------------------------TITLE END-------------------------------------------->
<div class="bg-light">
<!--------------------------------------------------END------------------------------------------------------>
<!---------------------------------WEB-HOSTING---------------------------------------------------------------->
<div class="container-fluid">
  <h4 class="font-weight-bolder align-middle text-center text-uppercase d-block d-sm-none">
    web hosting
  </h4>
    <div class="row" >
    <div class="col-md-5 col-sm-12 col-xs-12 animatable bounceInLeft" style="margin-top: 1%;">
                <div class="bg-light">
                  <!-- <div class="top-sec"> -->
                    <img src="./../../../assets/img/service/web-host/img-01.jpg" style="width:100%;">
                  <!-- </div> -->
                  <div class="bottom-sec">
          
                  </div>
                </div>
    </div>
    <div class="col-md-7 col-sm-12 col-xs-12" style="margin-top: 1%;">
        <h3 class="font-weight-bold">Web Hosting</h3>
        <p class="justify-content-center" style="text-indent: 5%;">
            Web Space is a small portion of a web server owned or rented by a web hosting company. 
            This process of transferring a website into server web space is Web Hosting.
            Web hosting is basically a web space service provider. Factors to be considered while buying web 
            space are Server Softwares, Space and Capacity.
            The common server types are Windows 2000, Unix and Linux. Disk space or Web Space is the size of 
            space allotted on a particular server for uploading the web pages and Band Width is an amount of transfer
            from the web server through internet. For a basic website, there is no need to bother about server type, disk
            space and band width, but if a website has data base then server type is very important as database suppor
            depends on its type. For example, a website with MS SQL database
            cannot be store in Linux Server but only in the Windows server. Annaa Silicon is currently developing mobile apps and mobile software components on
            iOS, Android.
        </p>
    </div>
  </div>
</div>

<!----------------------------------------------WEB-HOSTING END----------------------------------------------->

<!------------------------------------------TYPES OF WEB HOSTING---------------------------------------------->
<div class="container-fluid p-4">
    <div class="row">
      <div class="col-md-7 col-sm-12 col-xs-12" >
        <h3 class="font-weight-bold">Types of web hosting packages</h3>
          <p class="justify-content-center" style="text-indent: 5%;">
              Dedicated Hosting is expensive however very secure and highly recommended for websites 
              with huge traffic /having e-Commerce Shopping</p>
          <p class=" justify-content-center" style="text-indent: 5%;">
              Shared Hosting is competitively priced where thousands of websites will be hosted and 
              they share the same server and its features and works great for websites without any commerce
              / performance need.</p>
          <p class="justify-content-center" style="text-indent: 5%;">
              Co-Located web hosting is similar to dedicated hosting. Instead of having a own server 
              can be rented out and to take responsibility of maintaining the server completely like 
              except electricity, storage and internet facility.</p>
          <p class=" justify-content-center" style="text-indent: 5%;">
              Free Hosting is available based on promotions and often recommended for temporary sites/news casts.</p>
          <p class=" justify-content-center" style="text-indent: 5%;">
              Reseller Hosting which is similar to shared hosting with additional features of extra tools 
              in order to Re-Sell the serer or web space into many units to the end users under their own brand name.</p>
           <p class=" justify-content-center" style="text-indent: 5%;"> Annaa Silicon is currently developing mobile apps and mobile software components on
              iOS, Android.</p>
        </div>
        <div class="col-md-5 col-sm-12 col-xs-12"  >
          <div class="card">
              <!-- <div class="top-sec"> -->
                  <img src="./../../../assets/img/service/web-host/img-02.jpg"  style="width:100%;">
              <!-- </div> -->
              <div class="bottom-sec">
              </div>
          </div>
        </div>
    </div>
</div>

<!----------------------------------------------TYPES OF WEB HOSTING END--------------------------------------->


<!---------------------------------------------SEO SERVICES--------------------------------------------------->
<div class="container-fluid pb-3">
    <div class="row">
      <div class="col-md-5 col-sm-12 col-xs-12" >
        <div class="card">
            <!-- <div class="top-sec"> -->
              <img src="./../../../assets/img/service/web-host/img-03.jpg"  style="width:100%;">
            <!-- </div> -->
            <div class="bottom-sec">
    
            </div>
        </div>
      </div>
      <div class="col-md-7 col-sm-12 col-xs-12" >
        <h3 class="font-weight-bold">SEO Services</h3>
        <p class="justify-content-center" style="text-indent: 5%;">
          Search Engine Optimization ( SEO ) is a process of making a website or a portal to be
          Search Engine Friendly, to bring that particular website or a portal with the Top Ranking on a
          Search Engine Ranking Page ( SERP ) as top as possible for a query raised while surfing.
          This drives more traffic to the website and in turn increase customers to the portal.
          This is very key for driving growth to a business.
          </p>
      </div>
    </div>
</div>

<!------------------------------------------SEO SERVICES--------------------------------------------------->
</div>
 